// src/services/youtubeService.js
import axios from 'axios';

const API_KEY = 'AIzaSyDWMpTMT4W_fzoNEfzRYvdvNRexVfVjxu0';
//const API_KEY = 'AIzaSyD5mru1Vl2xqrxOQZGD_hVgAH1jPiN34YM';//backup

const BASE_URL = 'https://www.googleapis.com/youtube/v3';

export const fetchVideos = async (channelId) => {
    try {
        const response = await axios.get(`${BASE_URL}/search`, {
            params: {
                part: 'snippet',
                channelId,
                maxResults: 20,
                key: API_KEY,
            },
        });
        return response.data.items;
    } catch (error) {
        console.error('Error fetching YouTube videos:', error);
        return [];
    }
};

export const fetchVideoStatistics = async (videoIds) => {
    if (!videoIds.length) return {};
    try {
        const res = await axios.get(`${BASE_URL}/videos`, {
            params: {
                part: 'statistics',
                id: videoIds.join(','),
                key: API_KEY,
            },
        });
        // build a map: { [videoId]: { viewCount, likeCount… } }
        const map = {};
        res.data.items.forEach(item => {
            map[item.id] = item.statistics;
        });
        return map;
    } catch (error) {
        console.error('Error fetching video statistics:', error);
        return {};
    }
};